import React, { Fragment, useEffect, useState } from 'react';
import TableCommon from '../../../../components/common/table/TableCommon';
import { useParams } from 'react-router-dom';
import * as CommonService from '../../../../services/CommonService';
import { CUSTOMER_ENDPOINT, SUPPLIER } from '../../../../services/endpoint';
import { Button, message, Tag } from 'antd';
import { currencyVND, dateToString } from '../../../../utils';
import { ORDER_STATUS } from '../../../../utils/const';

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 1000000
};

export default () => {

	const { id } = useParams();
	const [ds, setDs] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [searchValues, setSearchValues] = useState({});

	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	useEffect(() => {
		const init = async () => {
			try {
				setLoading(true);
				const resp = await CommonService.get(`${CUSTOMER_ENDPOINT}/invoice-history/${id}`, {
					page: page.currentPage - 1,
					size: page.perpage
				});
				setDs(resp.data?.contents);
				setPage({ ...page, total: resp.data?.totalElements });
			} catch (error) {
				message.error(error?.data?.message || 'Có lỗi xảy ra');
			} finally {
				setLoading(false);
			}
		};
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(`${CUSTOMER_ENDPOINT}/invoice-history/${id}`, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã đơn hàng',
			dataIndex: 'invoiceCode',
			align: 'center',
			width: 150,
			// render: (text, record) => {
			// 	console.log(record);
			// 	return <Button style={{ padding: '0', height: 'fit-content' }} type={'link'}
			// 								 onClick={() => window.open('/supplier/' + record.id)}>{text}</Button>;
			// }
		},
		{
			title: 'Chi nhánh',
			dataIndex: 'branchName',
			width: 200,
			align: 'center'
		},
		{
			title: 'Giá trị',
			dataIndex: 'totalAmount',
			width: 250,
			align: 'center',
			render: (value) => currencyVND(value)
		},
		{
			title: 'Trạng thái',
			dataIndex: 'invoiceStatus',
			width: 110,
			align: 'center',
			render: (value) => {
				const status = ORDER_STATUS.find(el => el.value === value);
				return <Tag style={{ width: '110px' }} color={status.color}>{status.name}</Tag>
			}
		},
		{
			title: 'Nguồn đơn',
			dataIndex: 'source',
			width: 200,
			align: 'center'
		},
		{
			title: 'Nhân viên xử lý đơn',
			dataIndex: 'createdBy',
			width: 200,
			align: 'center'
		},
		{
			title: 'Ngày ghi nhận',
			dataIndex: 'paymentDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		}
	];

	return (
		<Fragment>
			<TableCommon
				loading={loading}
				bordered={true}
				page={page}
				setPage={setPage}
				datasource={ds}
				columns={columns}
				onSearch={onSearch}
				pagination={false}
			/>
		</Fragment>);
}
;

